var React = require('react');

function Brackets (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M9.354 3.147c-.195-.195-.512-.195-.707 0l-8.5 8.5c-.195.195-.195.512 0 .707l8.5 8.5c.097.097.225.146.353.146s.256-.049.354-.146c.195-.195.195-.512 0-.707l-8.147-8.147 8.147-8.146c.195-.196.195-.512 0-.707zM23.854 11.646l-8.5-8.5c-.195-.195-.512-.195-.707 0-.195.195-.195.512 0 .707l8.146 8.147-8.146 8.146c-.195.195-.195.512 0 .707.097.098.225.147.353.147s.256-.049.354-.146l8.5-8.5c.195-.196.195-.512 0-.708z"})));
}

Brackets.defaultProps = {"version":"1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Brackets;

Brackets.default = Brackets;
